import { watch, ref, onUnmounted } from 'vue'
import { useFormStore } from '@/stores/form'

const motherUnifiedNumberWatch = (options) => {
  const motherUnifiedNumberWatchRef = ref()
  const formStore = useFormStore()
  motherUnifiedNumberWatchRef.value = watch(
    () => formStore.form.values.motherUnifiedNumber,
    (newVal) => {
      const selectedWife = options.value.find((wife) => wife.unifiedNumber == newVal)
      formStore.draft.request = {
        ...formStore.draft.request,
        engMotherName: selectedWife.englishName,
        arbMotherName: selectedWife.arabicName
      }
    }
  )
  onUnmounted(() => {
    motherUnifiedNumberWatchRef.value && motherUnifiedNumberWatchRef.value()
  })
}
export default function () {
  return {
    motherUnifiedNumberWatch
  }
}
